var _defs, _rect, _line, _text, _text2, _g, _g2, _text3, _text4, _text5, _circle, _circle2, _path, _text6, _rect2, _text7, _line2, _g3, _g4, _g5, _text8, _text9, _text0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpanOfControlMath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1040 560",
    width: 1040,
    height: 560,
    role: "img",
    "aria-label": "Before and after: a layered management pyramid versus an AI-flattened org with a wide span of control",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171523"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2b24a"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .t   { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#f4f0fc; }\n      .cap { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#b8b2cc; }\n      .lay { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#efe9fa; }\n      .pill{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#121020; }\n      .k   { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#cfc3ee; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1040,
    height: 560,
    rx: 18,
    fill: "url(#bg2)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 60,
    x2: 520,
    y2: 500,
    stroke: "#2a2547",
    strokeWidth: 1.5,
    strokeDasharray: "6 8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 56,
    className: "t",
    fontSize: 26
  }, "Before: layered management")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 86,
    className: "cap",
    fontSize: 16
  }, "Every signal climbs and descends the pyramid.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 120,
    width: 150,
    height: 46,
    rx: 8,
    fill: "#2a2547",
    stroke: "#665a9c"
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 149,
    textAnchor: "middle",
    className: "lay",
    fontSize: 16
  }, "Executive"), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 192,
    width: 280,
    height: 46,
    rx: 8,
    fill: "#1d1a2e",
    stroke: "#4c4380"
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 221,
    textAnchor: "middle",
    className: "lay",
    fontSize: 16
  }, "Directors"), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 264,
    width: 390,
    height: 46,
    rx: 8,
    fill: "#1d1a2e",
    stroke: "#3a3463"
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 293,
    textAnchor: "middle",
    className: "lay",
    fontSize: 16
  }, "Middle managers"), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 336,
    width: 460,
    height: 46,
    rx: 8,
    fill: "#171523",
    stroke: "#342e57"
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 365,
    textAnchor: "middle",
    className: "lay",
    fontSize: 16
  }, "Team (the actual work)"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#f6a35a",
    strokeWidth: 2.5,
    fill: "none",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 359 C 540 300, 540 220, 500 150",
    markerEnd: "url(#ar)"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 250,
    className: "cap",
    fontSize: 13,
    fill: "#f6a35a"
  }, "slow")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 56,
    className: "t",
    fontSize: 26
  }, "After: AI-flattened")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 86,
    className: "cap",
    fontSize: 16
  }, "One leader sets intent; AI runs coordination.")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 170,
    r: 34,
    fill: "url(#gold2)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 160,
    r: 11,
    fill: "#121020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M622 186 a18 15 0 0 1 36 0 z",
    fill: "#121020"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 176,
    className: "lay",
    fontSize: 17
  }, "Leader (intent + judgment)")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 595,
    y: 240,
    width: 360,
    height: 52,
    rx: 26,
    fill: "url(#ai2)"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 775,
    y: 273,
    textAnchor: "middle",
    className: "pill",
    fontSize: 17
  }, "BossDrop AI coordination layer")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 204,
    x2: 700,
    y2: 240,
    stroke: "url(#ai2)",
    strokeWidth: 3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#ai2)",
    strokeWidth: 2,
    opacity: 0.7,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640 292 V 360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 292 V 360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760 292 V 360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 292 V 360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880 292 V 360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910 292 C 910 330, 700 330, 700 360"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#1d1a2e",
    stroke: "#665a9c",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 384,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680,
    cy: 384,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740,
    cy: 384,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 384,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 860,
    cy: 384,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 384,
    r: 19
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#cfc3ee"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 379,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680,
    cy: 379,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740,
    cy: 379,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 379,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 860,
    cy: 379,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 379,
    r: 5
  }))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 770,
    y: 430,
    textAnchor: "middle",
    className: "k",
    fontSize: 15
  }, "wider span, fewer layers, faster decisions")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 470,
    className: "cap",
    fontSize: 15
  }, "Span of control = direct reports \xF7 supervisors.  Raise the ratio without burning out the manager.")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 498,
    className: "k",
    fontSize: 15,
    opacity: 0.9
  }, "BossDrop absorbs the coordination that used to require a middle-management layer.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanOfControlMath);
export default __webpack_public_path__ + "static/media/span-of-control-math.4c24ede522bbd462ff364978ef85a8c6.svg";
export { ForwardRef as ReactComponent };